@if (dashParam === 'int' && isAdmin === true && dashItem.statNbDoc === true) {
  <dashboardstat></dashboardstat>
}
@if (dashParam === 'load' && dashItem.statLoad === true) {
  <dashbskload></dashbskload>
}
@if (dashParam === 'old' && dashItem.statOldDoc === true) {
  <dashbskold></dashbskold>
}
@if (dashParam === 'view' && dashItem.statView === true) {
  <dashlastdoc></dashlastdoc>
}
@if (dashParam === 'wrk' && dashItem.statWork === true) {
  <dashlastactiondoc></dashlastactiondoc>
}
@if (dashParam === 'em1' && dashItem.lastReq === true) {
  <dashlastrequest></dashlastrequest>
}
@if (dashParam === 'em2') {
  <div></div>
}
@if (dashParam === 'em3') {
  <div></div>
}
@if (dashParam === 'em4') {
  <div></div>
}
@if (dashParam === 'em5') {
  <div></div>
}